import Form from 'components/form/Form';
import { bindEmitterMethod } from 'helpers/bind';
import Category from 'sections/category/Category';
export default class SearchResults extends Category {
    constructor(el, options, pageManager) {
        super(el, options, pageManager);
        this.isSearch = true;
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            // pageHeader: ['.page-header__bottom', PageHeader],
            form: ['.search-form', Form]
        };
    }
    shouldRouteInternally(el) {
        // add offset
        const a = el.querySelector('.category__list');
        const b = this.modules.content.currentPage.el.querySelector('.category__list');
        if (!a || !b)
            return false;
        const searchA = (a.getAttribute('data-search') || '').split('?')[0];
        const searchB = (b.getAttribute('data-search') || '').split('?')[0];
        return searchA === searchB;
    }
    bindEvents(add) {
        super.bindEvents(add);
        const emitterMethod = bindEmitterMethod(add);
        this.modules.form?.[emitterMethod]('submitted', this.onFormSubmitted);
    }
    onFormSubmitted = (query) => {
        this.modules.form.setSubmitted(false);
    };
}
